import {forwardRef} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {useNavigate} from 'react-router-dom'

import Next from '@mui/icons-material/SkipNext'
import Pause from '@mui/icons-material/Pause'
import Previous from '@mui/icons-material/SkipPrevious'
import CloseIcon from '@mui/icons-material/Close'
import PlayArrow from '@mui/icons-material/PlayArrow'
import IconButton from '@mui/material/IconButton'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import {SiApplemusic} from 'react-icons/si'
// import {PiSpotifyLogoFill} from 'react-icons/pi'

import {Image} from '../generics'



const styles = {
  root: css`
    z-index: 100;
    background-color: #242639;
    display: flex;
    padding: 5px;
    border-radius: 8px;
    border-top-left-radius: 40px;
    border-bottom-left-radius: 40px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
    width: 280px;
    height: 80px;
    align-items: stretch;
  `,
  imageContainer: css`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    cursor: pointer;
  `,
  image: css`
    width: 70px;
    height: 70px;
    border-radius: 50%;
    object-fit: cover;
  `,
  hole: css`
    position: absolute;
    background-color: #fff;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    z-index: 11;
  `,
  musicServiceIcon: css`
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 11;
    width: 25px;
    height: 25px;
    color: #fc3c44;
    background-color: #fff;
    border-radius: 50%;
    cursor: pointer;
  `,
  controlsContainer: css`
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  playButton: css`
    width: 50px;
    height: 50px;
    background-color: rgb(255, 0, 149);
    color: #fff;
    box-shadow: 0px 10px 20px -3px rgba(255, 0, 149, 0.55);

    &:hover {
      background-color: rgb(255, 0, 149);
    }
  `,
  buttonsContainer: css`
    height: 70px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
  `,
  closeIcon: css`
    width: 20px;
    color: grey;
    cursor: pointer;
  `,
  expandIcon: css`
    color: grey;
    cursor: pointer;
  `,
}




const MediaPlayerCompact = forwardRef((props, ref) => {
  const navigate = useNavigate()

  const {
    image,
    isPlaying,
    // spotifyLink,
    appleMusicLink,
    handleClose,
    composerID,
    composerType,
    expandPlayer,
    playNextTrack,
    handlePlayClick,
    playPreviousTrack
  } = props



  function navigateToComposersPage(e) {
    e.stopPropagation()

    try {
      if (['event', 'performance'].includes(composerType.toLowerCase())) {
        navigate(`/performances/${composerID}`)
      } else {
        navigate(`/${composerType.toLowerCase()}s/${composerID}`)
      }
    } catch (error) {
      console.log(error)
    }
  }



  return (
    <div ref={ref} id='audio-player' css={styles.root}>
      <div css={styles.imageContainer}>
        <Image
          id='audio-player-image'
          src={image} 
          alt='track' 
          css={styles.image}
          onClick={navigateToComposersPage}
        />

        <div onClick={navigateToComposersPage} css={styles.hole} />

        {Boolean(appleMusicLink) &&
          <a href={appleMusicLink} target='_blank' rel='noreferrer'>
            <SiApplemusic css={styles.musicServiceIcon} /> 
          </a>
        }
      </div>



      <div css={styles.controlsContainer}>
        <IconButton onClick={playPreviousTrack} size='large'>
          <Previous color='secondary' />
        </IconButton>


        <IconButton size='large' css={styles.playButton} onClick={handlePlayClick}>
          {isPlaying ? <Pause /> : <PlayArrow />}
        </IconButton>


        <IconButton onClick={playNextTrack} size='large'>
          <Next color='secondary' />
        </IconButton>
      </div>



      <div css={styles.buttonsContainer}>
        <CloseIcon onClick={handleClose} css={styles.closeIcon} />

        <ExpandMoreIcon onClick={expandPlayer} css={styles.expandIcon} />
      </div>
    </div>
  )
})



export default MediaPlayerCompact





